module.exports = __webpack_public_path__ + "static/media/how-we-can-adapt-plants-to-save-our-planet-twitter.1a2b1e9a.jpg";